import { navigateWithAttribution } from '../composables/attributionNavigation.js';

export default {
    data() {
        return {
            updatedValueAddCode: this.valueAddCode,
            availableGasses: ['RCAIRCON', 'RCAIRCONYF'],
            availableAlignments: ['WHEELALIGNMENT', 'RCWHEELALIGN4'],
            fitter: null,
            car: null
        }
    },
    methods: {
        async onValueAddRegSubmit(values, actions) {
            this.emitter.emit('isLoading', true);

            var registration = values.reg_plate;
            var postcode = values.reg_postcode;
            let vm = this;

            var postcodeData = new FormData();
            postcodeData.append('postcode', values.reg_postcode);
            postcodeData.append('set_session', true);

            const postcode_response = await axios.post('/ajax/validate_postcode/', postcodeData);

            if(postcode_response.data.valid_postcode == true) {

                const reg_response = await axios.post('/ajax/validate_reg/' + registration);

                if(reg_response.data.car_exists == true)
                {
                    this.emitter.emit('updatedCar', reg_response.data.car);

                    //The array of items to check if they are in the basket
                    var itemsToCheck = [];
                    var unSelectedItem = null;

                    //If service is Air Con Regas, get correct upsell for the car age
                    var carYear = (reg_response?.data?.car?.date).split('-');

                    //If service is Aircon, default to correct gas for the year of car.
                    if(this.updatedValueAddCode.includes('RCAIRCON')) {
                        this.updatedValueAddCode = parseInt(carYear[0]) >= 2017 ? 'RCAIRCONYF' : 'RCAIRCON';
                        //itemsToCheck are all available gasses
                        itemsToCheck = this.availableGasses;
                        
                        unSelectedItem = this.availableGasses.filter(function(value){ 
                            return value != vm.updatedValueAddCode;
                        });
                    }
                    //If service is Wheel Alignment, default to Two Wheel Alignment.
                    else if(this.updatedValueAddCode.includes('WHEELALIGN')) {
                        this.updatedValueAddCode = 'WHEELALIGNMENT';
                        //itemsToCheck are all available alignments
                        itemsToCheck = this.availableAlignments;
                        
                        unSelectedItem = this.availableAlignments.filter(function(value){ 
                            return value != vm.updatedValueAddCode;
                        });
                    }
                    else {
                        //Pushes the single item into the array to check against
                        itemsToCheck.push(this.updatedValueAddCode);
                    }
                    
                    //Do a basket check, to see if the item is already in the basket
                    let basketCheck = await axios.post('/ajax/check_service_in_basket/' + itemsToCheck);

                    //If item is already in the basket, and its either air con or wheel alignment, just update the basket entry to the new selection
                    if(basketCheck.data.item_in_basket && unSelectedItem != null) {
                        await axios.post('/ajax/update_basket_item/' + unSelectedItem + '/' + this.updatedValueAddCode);
                    }
                    else if(!basketCheck.data.item_in_basket){
                        //Add product to basket, as modal_submit function expects a basket to exist
                        var basketData = new FormData();
                        basketData.append('st_code', this.updatedValueAddCode);
                        basketData.append('quantity', 1);
                        let response = await axios.post('/ajax/add_to_basket', basketData);
                        this.emitter.emit('updateBasket', response.data.basket);
                    }

                    //TODO: Cant use unselectedItem == null as we actually need this, as sometimes the modal opens without any options to select, aka Air Con regas for normal car.
                    //comment out for now, but just need to delete i think.
                    //unSelectedItem being null represents an ordinary service item, which isn't WA or AC.
                    // if(unSelectedItem == null) {
                        //Set service st_code to session, to filter fitters by later
                        var serviceData = new FormData();
                        serviceData.append('serviceCode', this.updatedValueAddCode);
                        await axios.post('/ajax/set_service_code_to_session', serviceData);
                    // }

                    //If valueAddCode is for Aircon regas or Wheel Alignment, launch confirmation modal
                    if(this.updatedValueAddCode.includes('RCAIRCON') || this.updatedValueAddCode.includes('WHEELALIGN')) {
                        var fitterData = new FormData();
                        fitterData.append('postcode', postcode);
                        fitterData.append('valueAddCode', this.updatedValueAddCode);

                        //Search for fitter that offers this service within [default range] of customers postcode
                        let fitter_response = await axios.post('/ajax/get_fitter_offering_cheapest_service', fitterData);

                        this.emitter.emit('isLoading', false);
                        this.emitter.emit('updatedFitter', fitter_response.data);

                        if(this.fitter?.services?.available?.length > 0) {
                            this.vaModalOpen = true;
                        }
                        else {
                            actions.setFieldError('reg_postcode', 'There are no fitters nearby that offer this service, please try another postcode.');
                        }
                    }
                    else {
                        //Post form as doesn't need specific modal logic
                        var formData = new FormData();
                        formData.append('postcode', this.postcode);

                        axios.post('/modal-submit', formData)
                        .then(response => {
                            void navigateWithAttribution(response.data);
                        })
                        .catch(error => {
                            console.error("There was an error!", error);
                        });
                    }
                }
                else {
                    this.emitter.emit('isLoading', false);

                    actions.setFieldError('reg_plate', 'Registration not found.');
                }
            }
            else {
                this.emitter.emit('isLoading', false);
                actions.setFieldError('reg_postcode', 'Invalid Postcode');
            }
        }
    }
};
